import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { IonToast } from '@ionic/react';
import { checkmarkCircleSharp, alertCircleOutline, warningOutline } from 'ionicons/icons';


const mapStateToProps = (state) => {
  return {
    toast: state.feedbackModal
  }
}

const mapDispatchToProps = {};

const FeedbackToast = ({toast}) => {

    const [showToast, setShowToast] = useState(false);
    const [toastIcon, setToastIcon] = useState("");

    useEffect(() => {
        if(toast){
            if(toast.open && toast.body){
                setShowToast(true);
            } else {
                setShowToast(false);
            }
            if(toast.color == "success"){
                setToastIcon(checkmarkCircleSharp);
            }
            else if(toast.color == "danger"){
                setToastIcon(alertCircleOutline);
            }
            else if(toast.color == "warning"){
                setToastIcon(warningOutline);
            }
        }
    }
    , [toast]);



    return (
        <>
            <IonToast
                key={`${toast?.body || ''}-${toast?.open || false}`}
                id='feedback-toast'
                isOpen={showToast && toast?.body}
                onDidDismiss={() => {setShowToast(false);}}
                message={toast?.body || ''}
                duration={4000}
                color={toast?.color || null}
                icon={toastIcon || null}
            />
        </>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackToast);